import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Shield, Activity, Users, AlertTriangle } from 'lucide-react';
import { AdminSecurityPanel } from './AdminSecurityPanel';
import { useAdminSecurity } from '@/hooks/useAdminSecurity';

export const AdminSecurityDashboard = () => {
  const { settings, auditLogs, loading } = useAdminSecurity();

  if (loading) {
    return (
      <Card>
        <CardContent className="p-6">
          <div className="flex items-center justify-center">
            <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-primary"></div>
          </div>
        </CardContent>
      </Card>
    );
  }

  const recentActivityCount = auditLogs.filter(log => 
    new Date(log.created_at) > new Date(Date.now() - 24 * 60 * 60 * 1000)
  ).length;

  const criticalActions = auditLogs.filter(log => 
    log.action_type.includes('lock') || log.action_type.includes('unlock') || log.action_type.includes('emergency')
  ).length;

  return (
    <div className="space-y-6">
      {/* Security Overview Cards */}
      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <Card>
          <CardContent className="p-4">
            <div className="flex items-center space-x-2">
              <Shield className="h-4 w-4 text-primary" />
              <div>
                <p className="text-xs font-light text-muted-foreground">Security Status</p>
                <p className="text-sm font-normal">
                  {settings?.is_locked ? 'Locked' : 'Active'}
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center space-x-2">
              <Activity className="h-4 w-4 text-primary" />
              <div>
                <p className="text-xs font-light text-muted-foreground">24h Activity</p>
                <p className="text-sm font-normal">{recentActivityCount}</p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center space-x-2">
              <Users className="h-4 w-4 text-primary" />
              <div>
                <p className="text-xs font-light text-muted-foreground">IP Restrictions</p>
                <p className="text-sm font-normal">
                  {settings?.allowed_ip_ranges?.length || 0} ranges
                </p>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card>
          <CardContent className="p-4">
            <div className="flex items-center space-x-2">
              <AlertTriangle className="h-4 w-4 text-destructive" />
              <div>
                <p className="text-xs font-light text-muted-foreground">Critical Actions</p>
                <p className="text-sm font-normal">{criticalActions}</p>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>

      {/* Security Panel */}
      <AdminSecurityPanel />
    </div>
  );
};